import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initDataLayer } from '@/lib/analytics/utils/gtag';
import { captureUtmFromUrl } from '@/lib/analytics/utmCapture';
import './index.css';
import App from './App.tsx';

// Inicializa dataLayer e gtag stub antes do React renderizar
initDataLayer();
captureUtmFromUrl();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
